import { db } from './index'
import { collection, addDoc, serverTimestamp } from 'firebase/firestore'

/**
 * 관심고객 등록
 * @param {Object} customerData - 고객 정보
 * @param {string} customerData.name - 성함
 * @param {string} customerData.gender - 성별
 * @param {string} customerData.ageGroup - 연령대
 * @param {string} customerData.phone - 연락처
 * @param {string} customerData.region - 사는지역
 * @param {string} customerData.consultTime - 상담 희망 시간대
 * @returns {Promise<string>} - 등록된 문서 ID
 */
export async function registerCustomer(customerData) {
  const docRef = await addDoc(collection(db, 'customers'), {
    name: customerData.name,
    gender: customerData.gender || '',
    ageGroup: customerData.ageGroup || '',
    phone: customerData.phone,
    region: customerData.region || '',
    consultTime: customerData.consultTime || '',
    source: customerData.source || 'website',
    status: 'new',
    createdAt: serverTimestamp()
  })
  return docRef.id
}
